/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![AngleBracketsIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABEUlEQVR4nGNgGAVDAgQGxogRI0YW8A0I9/ENCH+PKR7xycc/MpgSsxl9/cPLff3D//oFRPxHlwSJ+QVE/PMLiOgIDQ1lJsnk0NBQId+A8B1QQ/77+Uccx/RB+AmYPEgtSA9RhnsHhun7+YffhRseELHI1TWGG4sjOP0CImYiLIl45BMYZorXcH//8Ci/gIivYA3+Ed/8AsLzCTnIzy8szi8g/AvEp+Hf/QIikjAU2dvbs4DCEhEk4df9/aN0ifIyAwODT1Ckhm9A+CUkX88MDQ1lQ7jCP3wlkuR8bEFCCID0gPQiBdkKuCSIQ1ML7GkdRDDgGxARSXEk+4UlDlwypUtGo0tRQa/Cjj7F9ShgoDUAABNS1r2DB+CAAAAAAElFTkSuQmCC)
 */
export const AngleBracketsIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.6 7.8 4 12l5.6 4.2a1 1 0 0 1 .4.8v1.98c0 .21-.24.33-.4.2l-8.1-6.4a1 1 0 0 1 0-1.56l8.1-6.4c.16-.13.4-.01.4.2V7a1 1 0 0 1-.4.8ZM14.4 7.8 20 12l-5.6 4.2a1 1 0 0 0-.4.8v1.98c0 .21.24.33.4.2l8.1-6.4a1 1 0 0 0 0-1.56l-8.1-6.4a.25.25 0 0 0-.4.2V7a1 1 0 0 0 .4.8Z"
        className={colorClass}
      />
    </svg>
  );
};
